export enum AddOnCode {
  ExtendedTheftCover = 'E005',
  RSMD = 'E008',
}
